import { Grid, Typography } from '@mui/material';
import { LegalProceedingsAnnexesProps } from './props';
import { useLegalProceedingsAnnexes } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';

export const LegalProceedingsAnnexes = (
    props: LegalProceedingsAnnexesProps
) => {
    const { formik } = useLegalProceedingsAnnexes(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Anexos
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Observaciones"
                    name="observations"
                    rows={5}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.observations}
                    errors={formik.errors.observations}
                    value={formik.values.observations}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
